<template>
  <b-modal hide-footer title="Create Expense" :id="modalId">

    <!-- <div class="alert alert-primary"> -->
      <!-- <strong>Selected:</strong> {{ selectedText }} -->
    <!-- </div> -->

    <!-- Form -->
    <div class="form">

      <form @submit.prevent="createNewExpense">

        <div class="form-group mb-4">
          <label>Description</label>
          <textarea v-model="newExpense.description" name="description" id="description" rows="2"
            class="form-control"></textarea>
        </div>

        <div class="row">
          <div class="col-md-4">
            <div class="form-group mb-4">
              <label for="amount">Currency</label>
              <div class="btn-group">
                <button type="button" class="btn btn-itg" :class="{ 'active': newExpense.currency === 'GBP' }"
                  @click="setCurrency('GBP')">
                  £
                </button>
                <button type="button" class="btn btn-itg" :class="{ 'active': newExpense.currency === 'USD' }"
                  @click="setCurrency('USD')">
                  $
                </button>
                <button type="button" class="btn btn-itg" :class="{ 'active': newExpense.currency === 'JPY' }"
                  @click="setCurrency('JPY')">
                  ¥
                </button>
                <button type="button" class="btn btn-itg" :class="{ 'active': newExpense.currency === 'AUD' }"
                  @click="setCurrency('AUD')">
                  AU$
                </button>
              </div>
            </div>
          </div>
          <div class="col-md-8">
            <div class="form-group mb-4">
              <label for="amount">Amount</label>
              <input v-model="newExpense.amount" name="amount" id="amount" class="form-control" min="0" step="0.01"
                type="number">
            </div>
          </div>
        </div>

        <button type="submit" class="btn btn-itg-dark" :disabled="isSaving" @click.prevent="createNewExpense">Create
          Expense
        </button>

      </form>

    </div>
    <!-- / Form -->

  </b-modal>
</template>

<script>
import axios from 'axios';
import Forms from '../../../../../../mixins/Forms';
import LoadingScreen from '../../../../../../components/LoadingScreen.vue';
import Errors from '../../../../../../components/Errors.vue';
import { mapGetters, mapActions } from 'vuex';
import accounting from '../../../../../../helpers/accounting';

export default {
  props: ['selectedText', 'ticketNoteId'],

  data() {
    return {
      isLoading: false,
      isSaving: false,
      serverErrors: [],

      newExpense: {
        description: '',
        currency: 'GBP',
        amount: null
      }
    }
  },

  watch: {
    selectedText() {
      this.newExpense.description = this.selectedText.trim();

      // Attempt get amount from selected text
      let amount = accounting.unformat(this.selectedText);
      if (amount) {
        this.newExpense.amount = amount;
      }

      // Attempt get currency from selected text
      if (this.selectedText.includes('£')) {
        this.newExpense.currency = 'GBP';
      } else if (this.selectedText.includes('$')) {
        this.newExpense.currency = 'USD';
      } else if (this.selectedText.includes('¥')) {
        this.newExpense.currency = 'JPY';
      }
    }
  },

  mixins: [Forms],

  components: {
    LoadingScreen,
    Errors
  },

  methods: {
    ...mapActions('ticketViewer', {
      loadExpenses: 'loadExpenses'
    }),

    setCurrency(currency) {
      this.newExpense.currency = currency;
    },

    getFormData() {
      return {
        description: this.newExpense.description,
        currency: this.newExpense.currency,
        amount: Number(this.newExpense.amount) * 100
      };
    },

    createNewExpense() {
      let vm = this;
      vm.serverErrors = [];
      vm.isSaving = true;

      axios.post(API_BASE + '/tickets/' + this.ticket.id + '/expenses', this.getFormData()).then(r => {
        vm.isSaving = false;
        vm.newExpense = {
          description: '',
          currency: 'GBP',
          amount: null
        };
        this.$notify.success({
          title: 'Success!',
          message: 'Expense added successfully'
        });
        this.$emit('expense-added');
        this.loadExpenses();
        this.$bvModal.hide(this.modalId);
      }).catch(e => {
        console.log(e);
        vm.isSaving = false;
        vm.setErrors(e);
      });
    }
  },

  computed: {
    ...mapGetters('ticketViewer', {
      ticket: 'ticket'
    }),

    modalId() {
      return `ticket-note-context-menu-modal-${this.ticketNoteId}`;
    }
  }
}
</script>

<style></style>